import React from 'react';
import { Icon } from '@app/src/common/Icon';
import { Wrapper, Container, IconWrapper } from './styled';
import { COLORS } from '@app/src/ui';

interface Props {
  message?: string;
  isDisplay?: boolean;
  isClosable?: boolean;
  error?: boolean;
  handleClickClose?: Function;
}

export const FlashMessage: React.FC<Props> = ({
  message,
  isClosable,
  isDisplay,
  error,
  handleClickClose
}) => (
  isDisplay ?
    <Wrapper error={error}>
      <Container>
        <p>{message}</p>
        {
          isClosable &&
          <IconWrapper onClick={handleClickClose}>
            <Icon data-name="icon-close-bold" width="12" height="12" fill={error ? '#fff' : COLORS.YELLOW_DARK} />
          </IconWrapper>
        }
      </Container>
    </Wrapper> : null
);
